import { Form, Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "react-bootstrap";
import { getDepartmentsByOrganization } from "src/app/modules/utils/ServicesUtils";
import { KEY_LOCALSTORAGE } from "../../../auth/core/_consts";
import AutocompleteV2 from "../../../component/AutocompleteObjectV2";
import LabelRequired from "../../../component/LabelRequired";
import TextField from "../../../component/TextField";
import { ObjectSelectAutocomplete } from "../../../phan-he-tiep-nhan-thanh-toan/models/PhanHeTiepNhanModel";
import { getCategory } from "../../../utils/AppFunction";
import { LEVEL, LOAI_PHONG, TERM_CLASS_IDS } from "../../../utils/Constant";
import { localStorageItem } from "../../../utils/LocalStorage";
import InfoPatientRight from "../../components/InfoPatientRight";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import { searchExaminationClinic } from "../../utils/Utils";

type Props = {
  open: boolean;
  handleCloseModal: () => void;
  handleSubmit: (values: any) => void;
  modalityDetails?: any;
  setModalityDetails?: (values: any) => void;
};
interface IChuyenPhongKham {
  transferReason?: string;
  examinationRequest?: ObjectSelectAutocomplete | null;
  clinic?: ObjectSelectAutocomplete | null;
}


const ChuyenPhongKhamModal = ({
	open,
	handleCloseModal,
	handleSubmit,
	modalityDetails,
}: Props) => {
	const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
	
	const [listYCK, setListYCK] = useState<any>([]);

	const currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);

	useEffect(() => {
		handleGetDsDanhMuc();
	}, []);

	const handleGetDsDanhMuc = async () => {
		try {
			const dichVuKhamBenh = await getCategory(TERM_CLASS_IDS.KHAM_BENH);
			setListYCK(dichVuKhamBenh);
		} catch (error) {
			console.error(error);
		}
	};

	const handleSubmitForm = (values: IChuyenPhongKham) => {
		let submitData = {
			transferReason: values?.transferReason,
			examinationRequest: values?.examinationRequest?.id,
			clinic: values?.clinic?.code,
			transferOrderReq: {
				termId: values?.examinationRequest?.id,
				requestDeptCode: currentUser?.departments?.[0]?.code || '',
				requestDeptName: currentUser?.departments?.[0]?.name || '',
				fulfillDeptId: values?.clinic?.id,
				fulfillDeptCode: values?.clinic?.code,
				fulfillDeptName: values?.clinic?.name,
			},
		};
		handleSubmit({
			...modalityDetails,
			...submitData,
		});
	};

	return (
		<Modal show={open} centered size="lg" onHide={handleCloseModal}>
			<Formik<IChuyenPhongKham> initialValues={{}} onSubmit={handleSubmitForm}>
				{({ values, setFieldValue, handleChange }) => (
					<Form className="h-100">
						<ModalHeader closeButton className="header-modal">
							<Modal.Title>Chuyển phòng khám</Modal.Title>
						</ModalHeader>

						<ModalBody className="overflow-hidden spaces p-0 ">
							<InfoPatientRight benhNhanInfo={benhNhanInfo} />
							<Row className="spaces pt-10 px-10">
								<Col xs={12}>
									<LabelRequired label="Lý do chuyển phòng" />
									<TextField
										className="w-100 d-flex flex-column align-items-start flex-auto spaces  pre-line"
										name="transferReason"
										labelClassName="ms-0 min-w-145px"
										as="textarea"
										value={values?.transferReason || ''}
										onChange={handleChange}
									/>
								</Col>
							</Row>
							<Row className="spaces pt-10 px-10">
								<LabelRequired label="Yêu cầu khám" />
								<AutocompleteV2
									options={listYCK}
									onChange={async (option) => {
										setFieldValue('examinationRequest', option);
										const clinic = await searchExaminationClinic(
											option?.attributes?.deptClinicCode ||
												option?.attributes?.deptLaboratoryCode
										);
										setFieldValue('clinic', clinic);
									}}
									name="examinationRequest"
									value={values?.examinationRequest}
								/>
							</Row>
							<Row className="spaces pt-10 px-10">
								<LabelRequired label="Phòng khám" />
								<AutocompleteV2
									options={[]}
									searchFunction={getDepartmentsByOrganization}
									searchObject={{
										level: LEVEL.PHONG,
										type: LOAI_PHONG.PHONG_KHAM_BENH,
									}}
									isSrcoll
									isSearchable
									labelSearch="keyword"
									name="clinic"
									getOptionValue={(option) => option.code}
									onChange={(option) => setFieldValue('clinic', option)}
									getOptionLabel={(option) => `${option.code} - ${option.name}`}
									value={values?.clinic}
									urlData="data.content"
								/>
							</Row>
							<Row className="spaces pt-10 px-10 text-info">
								<em>Chú ý: </em>
								<Col xs={12} className="d-flex mb-3 flex-column">
									<em>
										- Sau khi chuyển phòng, hồ sơ bệnh án tại phòng khám này sẽ
										kết thúc
									</em>
									<em>
										- Toàn bộ quyền kê đơn, xử trí sẽ thuộc về phòng khám tiếp
										theo
									</em>
								</Col>
							</Row>
						</ModalBody>

						<ModalFooter className="d-flex justify-content-end py-2">
							<Button className="spaces px-16" type="submit">
								Lưu
							</Button>
						</ModalFooter>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export default ChuyenPhongKhamModal;
